/*
 * @Author: zengkai zengkai0702@gamil.com
 * @Date: 2025-08-14 10:26:33
 * @LastEditors: zengkai zengkai0702@gamil.com
 * @LastEditTime: 2025-08-25 09:20:36
 * @FilePath: /lxk_crm_web_h5/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory } from "vue-router";
// import { useStore } from "@/store/index";
// const store = useStore();
const routes = [
  {
    path: "/",
    component: () => import("@/views/home.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login.vue"),
  },
    {
        path: "/share",
        name: "share",
        component: () => import("@/views/share.vue"),
    },
  //   MyCenter  我的
  {
    path: "/myCenter",
    name: "myCenter",
    component: () => import("@/views/myCenter.vue"),
  },
  //   corpDetail  客户详情
  {
    path: "/corpDetail",
    name: "corpDetail",
    component: () => import("@/views/corpDetail/index.vue"),
  },
  // followRecord,
  {
    path: "/followRecord",
    name: "followRecord",
    component: () => import("@/views/followRecord.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
// 添加路由守卫
router.beforeEach((to, from, next) => {
    const params = to.query;
    console.log("params = ", params,to,from)
    const sourceFrom = params.sourceFrom;
    const fromWecom = params.from;

    if (sourceFrom === "wechat") {
        localStorage.setItem("sourceFrom", "wechat")
    }

    // 处理 from=wecom 的情况
    if (fromWecom === "wecom") {
        localStorage.setItem("fromWecom", "wecom")
        // 如果当前在首页，跳转到分享页
        if (to.path === "/") {
            next("/share");
            return;
        }
    }
  // 直接从 localStorage 读取 token（因为你使用了 persist: true）
  const storeData = localStorage.getItem("storeData");
  let token = "";

  if (storeData) {
    try {
      const parsedData = JSON.parse(storeData);
      token = parsedData.token || "";
    } catch (error) {
      console.error("解析 localStorage 数据失败:", error);
    }
  }

  // 检查路由是否需要认证
  if (to.meta.requiresAuth && !token) {
    // 避免重复跳转

    if (to.path !== "/login") {
      // 清除 localStorage 中的数据
      localStorage.removeItem("storeData");
      next("/login");
    } else {
      next(); // 如果已经在登录页，就继续
    }
  } else {
    next(); // 不需要认证，或者已经认证，就继续
  }
});

export default router;
